export type OperatorTab = 'phones' | 'dialer' | 'history'

interface Props {
  tab: OperatorTab
  onTabChange: (tab: OperatorTab) => void
  className?: string
}

const phonesIcon = (
  <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="5" y="2" width="14" height="20" rx="2" />
    <line x1="12" y1="18" x2="12" y2="18" />
  </svg>
)

const dialerIcon = (
  <svg className="w-7 h-7" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="5" cy="5" r="1.2" fill="currentColor" />
    <circle cx="12" cy="5" r="1.2" fill="currentColor" />
    <circle cx="19" cy="5" r="1.2" fill="currentColor" />
    <circle cx="5" cy="12" r="1.2" fill="currentColor" />
    <circle cx="12" cy="12" r="1.2" fill="currentColor" />
    <circle cx="19" cy="12" r="1.2" fill="currentColor" />
    <circle cx="5" cy="19" r="1.2" fill="currentColor" />
    <circle cx="12" cy="19" r="1.2" fill="currentColor" />
    <circle cx="19" cy="19" r="1.2" fill="currentColor" />
  </svg>
)

const historyIcon = (
  <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <polyline points="12 6 12 12 16 14" />
  </svg>
)

export function OperatorBottomNav({ tab, onTabChange, className = '' }: Props) {
  return (
    <nav
      aria-label="Operator navigation"
      className={`md:hidden flex items-center justify-around border-t border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 ${className}`}
    >
      <TabButton
        label="Трубки"
        active={tab === 'phones'}
        onClick={() => onTabChange('phones')}
        icon={phonesIcon}
      />
      <CenterButton
        label="Набор"
        active={tab === 'dialer'}
        onClick={() => onTabChange('dialer')}
      >
        {dialerIcon}
      </CenterButton>
      <TabButton
        label="История"
        active={tab === 'history'}
        onClick={() => onTabChange('history')}
        icon={historyIcon}
      />
    </nav>
  )
}

function TabButton({
  label,
  active,
  onClick,
  icon,
}: {
  label: string
  active: boolean
  onClick: () => void
  icon: React.ReactNode
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={active}
      aria-label={label}
      className={`flex-1 flex flex-col items-center gap-1 py-2 text-[11px] font-medium transition-colors ${
        active
          ? 'text-blue-600 dark:text-blue-400'
          : 'text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200'
      }`}
    >
      {icon}
      <span>{label}</span>
    </button>
  )
}

function CenterButton({
  label,
  active,
  onClick,
  children,
}: {
  label: string
  active: boolean
  onClick: () => void
  children: React.ReactNode
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={active}
      aria-label={label}
      className={`-mt-5 flex items-center justify-center w-14 h-14 rounded-full shadow-lg transition-colors ${
        active
          ? 'bg-blue-600 text-white hover:bg-blue-700'
          : 'bg-gray-900 text-white hover:bg-gray-700 dark:bg-gray-700 dark:hover:bg-gray-600'
      }`}
    >
      {children}
    </button>
  )
}
